import styled from "styled-components";

const Preview = styled.div`
  margin-bottom: 50px;
`;

export default Preview;
